import React, { useState, useRef } from 'react';
import { apiRequest, API_CONSTANTS } from '../libs/apiRequest';
import { useNavigate } from 'react-router-dom';
import '../css/gtc-register.css';

function GTCRegister() {
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const requestRef = useRef(false);

    const register = async () => {

        const form = new FormData();
        
        if (!name) {
            alert("Check input field name.");
            return;
        }
        form.append("name", name);

        if (!email) {
            alert("Check input field email.");
            return;
        }
        form.append("email", email);

        if (!password || !confirmPassword) {
            alert("Check input field password");
            return;
        }

        if (password != confirmPassword) {
            alert("Check your password");
            return;
        }
        form.append("password", password)
        form.append("confirmPassword", confirmPassword)

        try {
            if (requestRef.current) {
                return;
            }
            requestRef.current = true;
            const res = await apiRequest({
                method: "POST",
                api: API_CONSTANTS.PUBLIC_API,
                fn: "register",
                data: form
            })

            if (res && res.status == 200) {
                navigate(res.nextPath || "/verify");
            } else {
                alert("Registration not successful!");
                return;
            }
        } catch (error) {
            console.log(error);
            alert("Registration not successful!");
        }
        requestRef.current = false;
    }

    return (
        <div className="register-page">
            <div className="register-container">
                <div className="register-card">
                    <div className="register-header">
                        <h1 className="register-title">
                            <span style={{ color: "var(--secondary-color)" }}>Go</span>
                            Trycatch
                        </h1>
                        <h2 className="register-subtitle">Create an account</h2>
                        <p className="register-description">Join us and start using our services</p>
                    </div>

                    <div className="register-form">
                        <div className="form-row">
                            <label className="form-label">Name</label>
                            <input 
                                className="form-input"
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Enter your full name"
                            />
                        </div>

                        <div className="form-row">
                            <label className="form-label">Email</label>
                            <input 
                                className="form-input"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email address"
                            />
                        </div>

                        <div className="form-row">
                            <label className="form-label">Password</label>
                            <input 
                                className="form-input"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Create a strong password"
                            />
                        </div>

                        <div className="form-row">
                            <label className="form-label">Confirm Password</label>
                            <input 
                                className="form-input"
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="Confirm your password"
                            />
                        </div>

                        <a 
                            className="register-button"
                            onClick={register}
                        >
                            Create Account
                        </a>

                        <p className="login-link-text">
                            Already have an account?{' '}
                            <a href="/login" className="login-link">Sign in</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GTCRegister;